<template>
  <div class="saving">
    <v-fade-transition>
      <v-progress-circular
          class="spinner"
          v-show="globalLoading || showMessage"
          :color="color" :indeterminate="indeterminate" :value="indeterminate ? 0 : 100"
          size="45" width="2">
        <v-icon size="20" :color="color">{{ icon }}</v-icon>
      </v-progress-circular>
    </v-fade-transition>

  </div>
</template>
<script>
import {mapState} from 'vuex'

export default {
  name: 'GlobalFloatingSpinner',
  data() {
    return {
      icon: 'fa-save',
      color: 'primary',
      indeterminate: true,
      showMessage: false
    }
  },
  computed: {
    ...mapState(['globalLoading'])
  },
  methods: {},
  watch: {
    globalLoading(val) {
      var vm = this
      if (val) {
        vm.icon = 'fa-save'
        vm.color = 'primary'
        vm.indeterminate = true
        vm.showMessage = true
      } else {
        vm.icon = 'fa-check'
        vm.color = 'success lighten-1'
        vm.indeterminate = false
        setTimeout(function () {
          vm.showMessage = false
        }, 2000)
      }
    }
  }
}
</script>

<style scoped>

.spinner {
  border-radius: 25px
}

.saving {
  z-index: 10;
  position: fixed;
  bottom: 10px;
  right: 10px;
}
</style>